import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=2e9f196e&scoped=true"
import script from "./orderDetails.vue?vue&type=script&lang=js"
export * from "./orderDetails.vue?vue&type=script&lang=js"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=2e9f196e&prod&lang=less&scoped=true"
import style1 from "./orderDetails.vue?vue&type=style&index=1&id=2e9f196e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9f196e",
  null
  
)

export default component.exports